import * as React from 'react';
import { GradientSwatchWrapper } from './GradientSwatch_SC';

export interface Props {
  gradient: string;
}

export const GradientSwatch: React.FC<Props> = (props) => {
  const { gradient } = props;

  return <GradientSwatchWrapper gradient={gradient} />;
};
